import { useMemo } from "react";
import { useGetExpenseQuery, useGetExpensesQuery } from "./expenseEndpoints";
import { Expense } from "../../entities/expense";

export function useExpense(expenseID: number | undefined) {
  const expenseQuery = useGetExpenseQuery(expenseID ?? 0, {
    skip: (expenseID ?? 0) <= 0,
  });
  const expenseEntity = expenseQuery.data;

  return useMemo(() => {
    const ret: typeof expenseQuery & { expense?: Expense | undefined } = {
      ...expenseQuery,
    };
    if (expenseEntity) ret.expense = new Expense(expenseEntity);
    return ret;
  }, [expenseEntity]);
}

export function useExpenses(params?: any, options?: any) {
  const expenseQuery = useGetExpensesQuery(params, options);
  const expenseEntitiesMap = expenseQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof expenseQuery & {
      expenses?: Expense[];
      expensesMap?: { [id: number]: Expense };
    } = {
      ...expenseQuery,
      expenses: [],
      expensesMap: {},
    };
    if (expenseEntitiesMap) {
      const expenses: Expense[] = [];
      const expensesMap: { [id: number]: Expense } = {};

      for (const key in expenseEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(expenseEntitiesMap, key)) {
          const c = expenseEntitiesMap[key];
          const expense = new Expense(c);
          expenses.push(expense);
          expensesMap[expense.id] = expense;
        }
      }
      ret.expenses = expenses;
      ret.expensesMap = expensesMap;
    }

    return ret;
  }, [expenseEntitiesMap]);
}
